import {Controller} from "@hotwired/stimulus"
// Bundle = all modules (same as CDN swiper-bundle). Base CSS: application.tailwind.css imports swiper-bundle.css.
import Swiper from "swiper/bundle"

// data-controller="onboarding"
// Targets: carousel, nextButton, nextText
// Values: completePath
export default class extends Controller {
    static targets = ["carousel", "nextButton", "nextText"]
    static values = {completePath: String}

    get carouselElement() {
        return this.carouselTarget?.querySelector(".onboarding-carousel")
    }

    connect() {
        // After layout (flex heights) so Swiper can measure the viewport
        requestAnimationFrame(() => this.initSwiper())
    }

    disconnect() {
        this.destroySwiper()
    }

    destroySwiper() {
        if (this.swiperInstance) {
            this.swiperInstance.destroy(true, true)
            this.swiperInstance = null
        }
    }

    initSwiper() {
        const carousel = this.carouselElement
        if (!carousel) return

        this.destroySwiper()

        this.swiperInstance = new Swiper(carousel, {
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 300,
            allowTouchMove: true,
            autoHeight: true,
            observer: true,
            observeParents: true,
            watchOverflow: true,
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            },
            on: {
                slideChange: (swiper) => {
                    this.updateButtonText(swiper.activeIndex)
                }
            }
        })

        requestAnimationFrame(() => {
            this.swiperInstance?.update()
            this.updateButtonText(this.swiperInstance?.activeIndex ?? 0)
        })
    }

    nextOrComplete() {
        if (!this.swiperInstance) return

        const {activeIndex, slides} = this.swiperInstance
        const isLastSlide = activeIndex >= slides.length - 1

        if (isLastSlide) {
            window.location.href = this.completePathValue
            return
        }

        this.swiperInstance.slideNext()
    }

    updateButtonText(activeIndex = null) {
        if (!this.hasNextTextTarget) return
        if (!this.swiperInstance) return

        const idx = activeIndex === null || activeIndex === undefined
            ? this.swiperInstance.activeIndex
            : activeIndex
        const totalSlides = this.swiperInstance.slides.length
        const isLastSlide = idx >= totalSlides - 1

        const nextText = this.nextTextTarget.dataset.nextText
        const startText = this.nextTextTarget.dataset.startText

        if (isLastSlide) {
            this.nextTextTarget.textContent = startText
        } else {
            this.nextTextTarget.textContent = nextText
        }
    }
}
